import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";

@Component({
  selector: 'page-archive-user-wise-report',
  templateUrl: 'archive-user-wise-report.html',
})
export class ArchiveUserWiseReportPage {

  SourseWiseReport:any;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.loadvalues();
    });
  }


  ionViewDidLoad(){
    console.log('ionViewDidLoad ArchiveUserWiseReportPage');
  }

  loadvalues(){

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.SourseWiseReport = [];

    this.service.httpcall('app_web_service/get_archive_userwise_report?').subscribe(data => {

      this.SourseWiseReport = data;
      console.log('STDWiseReport',this.SourseWiseReport);
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/archive-user-wise-report/archive-user-wise-report.ts